<template>
  <div class="mine">
    <van-row class="mine-head">
      <van-col :span="7" :offset="1">
        <van-image
          round
          width="5rem"
          height="5rem"
          fit="cover"
          :src="require('../assets/head.jpg')"
        />
      </van-col>
      <van-col :span="16" style="padding-top: 2rem; font-weight: 600;">
        {{ currClient.name }}
      </van-col>
    </van-row>
    <br />
    <div class="block-card">
      <van-cell  title="切换企业" icon="exchange"   arrow-direction="down"   @click="showClientList = true"  is-link   />
      <br />
      <van-cell title="绑定企业" icon="user-circle-o" to="/bind-user" is-link>
      </van-cell>
      <br />
      <van-cell title="企业信息" icon="edit" to="/client-info" is-link>
      </van-cell>
      <br />
      <van-cell title="服务评价" icon="good-job-o" is-link to="/service-score">
      </van-cell>
    </div>
    <change-company :show="showClientList" @change="showClientList = $event" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ChangeCompany from "./commons/change-company";
export default {
  components: { ChangeCompany },
  data() {
    return {
      showClientList: false
    };
  },
  computed: {
    ...mapGetters(["currClient"])
  }
};
</script>
<style lang="less">
.mine {
  .mine-head {
    margin: 1.5rem;
    padding: 0.5rem;
    background: #eee;
    border-radius: 10px;
  }
  .block-card {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mine.vue